import { getPublicRestClient, getRestClient } from "../client";
import { CustomerCommunicationSearch, OrderResponse } from "../graphql/generated/generated";
export interface CreateOrderInput {
  payload: string;
  payment: string;
  currency: string;
  webhookUrl?: string;
  shippingClassification: string;
  destination: {
    name: string;
    company: string;
    address1: string;
    address2: string;
    address3: string;
    city: string;
    state: string;
    postal: string;
    country: string;
    phone: string;
    email: string;
  };
  orderItems: Array<{
    sku: string;
    quantity: number;
    retailPrice: string;
    itemDescription: string;
    product: {
      coverUrl: string;
      gutsUrl: string;
      pageCount: string | number;
    };
  }>;
}

export interface CreateOrderResponse {
  customerOrderId: string;
  statusCode: number;
  statusDescription: string;
}

export const exportCommunicationsCSV = async (body: CustomerCommunicationSearch, authHeader: string) => {
  return getPublicRestClient().post<Blob>("/internal/openapi-backend/admin/export/customerCommunications", body, {
    headers: {
      Authorization: authHeader,
    },
    responseType: "blob",
  });
};

const postCreateOrder = async (body: CreateOrderInput | Record<string, unknown>, authHeader: string) => {
  return getRestClient().post<CreateOrderResponse>("/orders/create", body, {
    headers: {
      Authorization: authHeader,
    },
  });
};

export const createOrder = async (body: CreateOrderInput, authHeader: string) => {
  return postCreateOrder(body, authHeader);
};

// Takes a body the caller typed rather than one this app assembled, so a deliberately wrong-shaped
// payload reaches the backend and its error can be shown. `createOrder` stays strictly typed.
export const createOrderFromJsonBody = async (body: Record<string, unknown>, authHeader: string) => {
  return postCreateOrder(body, authHeader);
};

export const getOrderById = async (customerOrderId: string, authHeader: string) => {
  // Encoded because callers pass ids typed by hand, and a customer order id may contain `#` or `/`.
  return getRestClient().get<Omit<OrderResponse, "__typename">>(`/orders/${encodeURIComponent(customerOrderId)}`, {
    headers: {
      Authorization: authHeader,
    },
  });
};
